var map = {
	"./17-bm.webp": 1164,
	"./17-cn.webp": 1165,
	"./17.webp": 1166,
	"./27-bm.webp": 1167,
	"./27-cn.webp": 1168,
	"./27.webp": 1169,
	"./7-bm.webp": 1170,
	"./7-cn.webp": 1171,
	"./7.webp": 1172,
	"./angpao-bg-mobile.jpg": 1173,
	"./angpao-bg.jpg": 1174,
	"./angpao-bm.webp": 1175,
	"./angpao-cn.webp": 1176,
	"./angpao.webp": 1177,
	"./button.png": 1178,
	"./close-eye.png": 1179,
	"./coin-1.png": 1180,
	"./coin.png": 1181,
	"./ketupak-open.png": 1182,
	"./ketupak.png": 1183,
	"./ketupak_ribbon.png": 1184,
	"./rain-1.png": 1185,
	"./rain-2.png": 1186,
	"./rain-3.png": 1187,
	"./raya-bg-mobile.png": 1188,
	"./raya-bg.png": 1189,
	"./shine.png": 1190,
	"./star-1.png": 1191,
	"./star-2.png": 1192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 456;